import comp from "./ApplyToMultipleStudentsModal";
export default comp;
